<eqa-host>
	<router-outlet></router-outlet>
</eqa-host>
<div class="modal" role="dialog" id="roowix-modal">
	<div class="panel-center" role="document" id="roowix-body-modal-center"></div>
	<div class="panel-right" role="document" id="roowix-body-modal"></div>
	<div class="panel-left" role="document" id="roowix-body-modal-left"></div>
</div>
